import Status from '@ably/ui/core/Status';

export default Status;
